import React, { createContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import activity from "../activity/activityLogger";
import {
  asyncSessionStorageGet,
  asyncSessionStorageSet,
} from "../activity/common";
import { SHARE_METHOD_COPY, SHOULD_LOG_ACTIVITY } from "../constants";

export const LogContext = createContext("");

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Log({ children, ...directProps }) {
  const query = useQuery();
  const ref = useRef({
    combinedProps: {},
  });
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (SHOULD_LOG_ACTIVITY) {
      const activityLogger = async () => {
        if (directProps.logImpression && directProps.eventName) {
          if (directProps.eventName === "page-visit") {
            const { referringData, ...rest } =
              await asyncSessionStorageGet("previousActivity");

            if (query.get("ref")) {
              ref.current.combinedProps["referringData"] = {
                redirectedFrom:
                  query.get("ref") === SHARE_METHOD_COPY
                    ? `Copied link`
                    : query.get("ref"),
              };
            } else {
              ref.current.combinedProps["referringData"] = rest;
            }
          }

          delete ref.current.combinedProps["logImpression"];
          ref.current.combinedProps["page"] = pathname;
          ref.current.combinedProps["queryString"] = search;

          activity.log([
            {
              ...ref.current.combinedProps,
              timeStamp: new Date().getTime(),
            },
          ]);

          asyncSessionStorageSet("previousActivity", ref.current.combinedProps);
        }
      };
      activityLogger();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, search]);

  return (
    <LogContext.Consumer>
      {(consumedProps) => {
        ref.current.combinedProps = { ...consumedProps, ...directProps };
        return (
          <LogContext.Provider value={ref.current.combinedProps}>
            {children}
          </LogContext.Provider>
        );
      }}
    </LogContext.Consumer>
  );
}

export default Log;
